export enum CoverageGroupTypeEnum {
    Default = 'default',
    Dynamic = 'dynamic',
    Disabled = 'disabled',
    Implicit = 'implicit',
    Radio = 'radio',
    Toggle = 'toggle',
    Table = 'table',
    Card = 'card'
}
